<template>
  <div class="page-welcome">
      <div class="welcome-text">
          Welcome to
          <br>SR Biomedical
      </div>
      <div class="welcome-img">
          <img src="../../assets/welcome.png" width="100%">
      </div>
  </div>
</template>

<script>
export default {
  mixins: [],
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.page-welcome{
    height: calc(100% - 1px);//100%;
    background-color: #FBFBFB;
    position: relative;

    .welcome-text{
        position:absolute;
        left :160px;
        top:109px;
        font-size:48px;
        color:rgba(84,111,147,1);
        line-height:80px;
    }

    .welcome-img{
        position: absolute;
        right:0;
        bottom: 0;
        width:600px;
    }
    
}
</style>